import { useState } from 'react'

import { DownloadSquare01Icon } from '@hugeicons/react'
import _ from 'lodash'

import { useLevelPlaySurface } from '@/shared/level-play'


export const LevelPlayFile = ({ activity }) => {
  const { meta } = activity
  const { isSubmitting } = useLevelPlaySurface()
  const [downloaded, setDownloaded] = useState(false)
  const fileUrl = _.get(meta, 'file.file.url')

  const handleDownload = () => {
    setDownloaded(true)
    window.open(fileUrl, '_blank')
  }

  return (
    <div
      className="w-full h-[200px] bg-gray-100 rounded-lg border-2 border-brand flex flex-col items-center justify-center cursor-pointer bg-sky-50 gap-4"
      onClick={handleDownload}
    >
      <DownloadSquare01Icon size={50} variant="duotone" className="text-sky-500" />
      <span className="font-bold text-gray-900 text-base">Clique para baixar</span>
    </div>
  )
}
